/* eslint-disable */
import Filterizr from 'filterizr';
import portfolio from '../util/portfolio';
import insights from '../util/insights';
import { post } from 'jquery';
export default {
  init() {



    Filterizr.installAsJQueryPlugin($);
    // JavaScript to be fired on all pages

    /**
     * General helper function to support toggle functions.
     */
    var toggleClasses = function(element) {
      var $this = element,
          $togglePrefix = $this.data('prefix') || 'this';

      // If the element you need toggled is relative to the toggle, add the
      // .js-this class to the parent element and "this" to the data-toggled attr.
      if ($this.data('toggled') == "this") {
        var $toggled = $this.closest('.js-this');
      }
      else {
        var $toggled = $('.' + $this.data('toggled'));
      }
      if ($this.attr('aria-expanded', 'true')) {
        $this.attr('aria-expanded', 'true')
      }
      else {
        $this.attr('aria-expanded', 'false')
      }
      $this.toggleClass($togglePrefix + '-is-active');
      $toggled.toggleClass($togglePrefix + '-is-active');

      // Remove a class on another element, if needed.
      if ($this.data('remove')) {
        $('.' + $this.data('remove')).removeClass($this.data('remove'));
      }
    };

    /*
     * Toggle Active Classes
     *
     * @description:
     *  toggle specific classes based on data-attr of clicked element
     *
     * @requires:
     *  'js-toggle' class and a data-attr with the element to be
     *  toggled's class name both applied to the clicked element
     *
     * @example usage:
     *  <span class="js-toggle" data-toggled="toggled-class">Toggler</span>
     *  <div class="toggled-class">This element's class will be toggled</div>
     *
     */
    $('.js-toggle').on('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      toggleClasses($(this));
    });

    // Toggle parent class
    $('.js-toggle-parent').on('click', function(e) {
      e.preventDefault();
      var $this = $(this);
      $this.toggleClass('this-is-active');
      $this.parent().toggleClass('this-is-active');
    });

    // Prevent bubbling to the body. Add this class to the element (or element
    // container) that should allow the click event.
    $('.js-stop-prop').on('click', function(e) {
      e.stopPropagation();
    });

    // Toggle hovered classes
    $('.js-hover').on('mouseenter mouseleave', function(e) {
      e.preventDefault();
      e.stopPropagation();
      toggleClasses($(this));
    });

    $('.js-hover-parent').on('mouseenter mouseleave', function(e) {
      e.preventDefault();
      var $this = $(this);
      $this.toggleClass('this-is-active');
      $this.parent().toggleClass('this-is-active');
    });

    var contents = $('.c-accordion__body');
    var titles = $('.c-accordion__item');
    titles.on('click', function () {
      var title = $(this);
      contents.filter(':visible').slideUp(function () {
        $('.c-accordion__group li').removeClass('is-opened');
      });

      var content = title.find('.c-accordion__body');

      if (!content.is(':visible')) {
        content.slideDown(function () { title.addClass('is-opened') });
      }
    });

    if(document.querySelector('.o-external-link')) {
      window.location.replace($('.o-external-link').attr('data-external'));
    }

    // For pages with 2 '.filtr-container' elements,
    // Which currently (2/6/24) includes all child pages of the 1st navigation item "Expertise'
    if ($('.filtr-container')) {
      if ($('.filtr-container').length > 1) {
        const filterizr =  $('.filtr-container').each(function(index, element) {
          if(index === 1) {
            $(element).addClass('filtr-container2');
          }
        });
      }
    }

    if ($('.filtr-container').length > 0) {
      const filterizr = $('.filtr-container').filterizr({
        gridItemsSelector: '.filtr-item',
        filter: location.hash ? location.hash.replace("#", "") : 'all',
        setupControls: true,
        gutterPixels: 20,
        spinner: {
          enabled: true,
          fillColor: '#e6378d',
          styles: {
            height: '75px',
            margin: '0 auto',
            width: '75px',
            'z-index': 2,
          },
        },
      });
      filterizr.filterizr('sort', 'title', 'asc');
      $('.c-team__categories-selected').text(location.hash ? location.hash.replace("#", "").replace("-", " ") : "All")
      $(".c-team__categories-menu").on('click', 'li', function () {
        $(this).siblings().removeClass('active');
        $(this).addClass('active');
        $('.c-team__categories-selected').text($(this).text());
        location.hash = "#" + $(this).text().replace(" ", "-").toLowerCase();
      });
    }
    if ($('.filtr-container2').length > 0) {
        const filterizr2 = $('.filtr-container2').filterizr({
          gridItemsSelector: '.filtr-item',
          filter: location.hash ? location.hash.replace("#", "") : 'all',
          setupControls: true,
          gutterPixels: 20,
          spinner: {
            enabled: true,
            fillColor: '#e6378d',
            styles: {
              height: '75px',
              margin: '0 auto',
              width: '75px',
              'z-index': 2,
            },
          },
        });

      filterizr2.filterizr('sort', 'title', 'asc');


      $('.c-companies__categories-selected').text(location.hash ? location.hash.replace("#", "").replace("-", " ") : "All");

      $(".c-companies__categories-menu").on('click', 'li', function () {
        $(this).siblings().removeClass('active');
        $(this).addClass('active');
        $('.c-companies__categories-selected').text($(this).text());
        location.hash = "#" + $(this).text().replace(" ", "-").toLowerCase();
      });


    }

    // Start load more functionality for posts in /updates
    const singlePosts = document.querySelectorAll('.filtr-post');
    let postArray = [];
    let frontEndArray = [];
    
    // Only fires on first load - get all posts and store in postArray then remove all posts after the 8th post
    if(singlePosts) {
      singlePosts.forEach((item, index) => {
        let updatedItem = item.outerHTML;
        postArray.push(updatedItem);

        if(index > 7) {          
          item.remove();
        }
      });               
    }    

    // Initialize filtr-posts the 1st time
    if ($('.filtr-posts').length > 0) {
      const filterizrPosts = $('.filtr-posts').filterizr({
        gridItemsSelector: '.filtr-post',
        setupControls: true,
        layout: 'sameWidth',
        filter: location.hash ? location.hash.replace("#", "") : 'all',
        gutterPixels: 20,
        spinner: {
          enabled: true,
          fillColor: '#e6378d',
          styles: {
            height: '75px',
            margin: '0 auto',
            width: '75px',
            'z-index': 2,
          },
        }
      });     

      // setTimeout(function () { filterizrPosts.filterizr('sort', 'date', 'dec'); }, 2900);

      // Load more on click functionality
      location.hash === '#all' || location.hash === '' ? $('.u-load-more').show() : $('.u-load-more').hide();

      if ($('.u-load-more').length > 0) {       
        $('.u-load-more').on('click', () => {
          // If postArray is empty, hide the load more button
          if(postArray.length === 0) {
            $('.u-load-more').hide();
          }

          // Remove the first 16 items from the postArray
          let removedItems = postArray.slice(0,16);

          // Push the removed items into the second array
          frontEndArray.push.apply(frontEndArray, removedItems);

          // Officially remove (mutate) the first 16 items from the postArray
          if(postArray.length > 0) {
            postArray.splice(0,16);
          }          

          // Clear existing content in the container
          $('.c-posts__list').empty();

          // Add the new items to .c-posts__list
          $.each(frontEndArray, function(index, html) {
            $('.c-posts__list').append(html);
          });

          // Re-render filterizr
          const filterizrPosts = $('.filtr-posts').filterizr({
            gridItemsSelector: '.filtr-post',
            setupControls: true,
            layout: 'sameWidth',
            filter: location.hash ? location.hash.replace("#", "") : 'all',
            gutterPixels: 20,
            spinner: {
              enabled: true,
              fillColor: '#e6378d',
              styles: {
                height: '75px',
                margin: '0 auto',
                width: '75px',
                'z-index': 2,
              },
            },
          });
          setTimeout(function () { filterizrPosts.filterizr('sort', 'date', 'dec'); }, 50);           
        });
      }

      // Category dropdown functionality
      $('.c-posts__categories-selected').text(location.hash ? location.hash.replace("#", "").replace("-", " ") : "All");

      $(".c-posts-menu").on('click', 'li', function () {
        $(this).siblings().removeClass('active');
        $(this).addClass('active');
        $('.c-posts__categories-selected').text($(this).text());
        location.hash = "#" + $(this).text().replace(" ", "-").toLowerCase();
      });

      $(".c-posts__categories-menu").on('click', 'li', function () {
        $(this).siblings().removeClass('active');
        $(this).addClass('active');
        $('.c-posts__categories-selected').text($(this).text());
        location.hash = "#" + $(this).text().replace(" ", "-").toLowerCase();

        $('.c-posts__categories-selected').text() !== 'All' ? $('.u-load-more').hide() : $('.u-load-more').show();
        location.hash === '#all' || location.hash === '' ? $('.u-load-more').show() : $('.u-load-more').hide();
      });
    }    

    const observer = new IntersectionObserver(
      (entries, observer) => {
        // Observer Callback
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // Toggle class.
            if (entry.target.dataset.toggleClass) {
              entry.target.classList.add(entry.target.dataset.toggleClass);
            }
            // Only allow event once.
            if (entry.target.dataset.doOnce) {
              observer.unobserve(entry.target);
            }
          } else {
            if (entry.target.dataset.toggleClass) {
              entry.target.classList.remove(entry.target.dataset.toggleClass);
            }
          }
        });
      },
      {
        /*
         * Margin around the root.
         * Can have values similar to the CSS margin property,
         * e.g. "10px 20px 30px 40px" (top, right, bottom, left).
         * The values can be percentages. This set of values serves
         * to grow or shrink each side of the root element's bounding
         * box before computing intersections. Defaults to all zeros.
         */
        rootMargin: "0px 0px",
        /*
         * Either a single number or an array of numbers which indicate
         * at what percentage of the target's visibility the observer's
         * callback should be executed. If you only want to detect when
         * visibility passes the 50% mark, you can use a value of 0.5.
         * If you want the callback to run every time visibility passes
         * another 25%, you would specify the array [0, 0.25, 0.5, 0.75, 1].
         * The default is 0 (meaning as soon as even one pixel is visible,
         * the callback will be run). A value of 1.0 means that the
         * threshold isn't considered passed until every pixel is visible.
         */
        threshold: 0.1
      }
    );
    if ($(".js-observe").length > 0) {
      // Add elements to observer.
      [...document.querySelectorAll(".js-observe")[0]].forEach((el) => {
        observer.observe(el);
      });
    }

    // mailchimp form - in footer
    const mailchimpForm = document.querySelector('.c-mailchimp-form');
    const mailchimpFormMsg = document.querySelector('.c-newsletter-signup__message');
    const mailchimpFormHeader = document.querySelector('.c-newsletter-signup__header');

    if(mailchimpForm) {
      mailchimpForm.addEventListener('submit', (e) => {
        e.preventDefault();
        const checkbox = document.querySelector('.c-newsletter-signup__form-disclaimer-checkbox');
        const emailAddress = document.querySelector('.c-mailchimp-form input[name="email"]').value;
        let user = {};
        user.email = emailAddress;

        if(emailAddress && checkbox.checked) {
          $.ajax({
              method: 'POST',
              url: '/wp-content/themes/ventures/app/mailchimp.php',
              data: user,
          }).done(function(response){
            if(response.toLowerCase().indexOf('member exists') >= 0) {
              alert('You\'re already a newsletter subscriber.');
              checkbox.checked = false;
              document.querySelector('.c-mailchimp-form input[name="email"]').value = '';
            } else if(response.toLowerCase().indexOf('member does not exist') >= 0) {
              // Member gets added server side, show success message on frontend
              mailchimpForm.style.display = 'none';
              mailchimpFormHeader.style.display = 'none';
              mailchimpFormMsg.innerText = 'You\’ve been registered, thank you so much!';
              checkbox.checked = false;
              document.querySelector('.c-mailchimp-form input[name="email"]').value = '';
            }
          }).fail(function(response){
            if(response.status === 500) {
              alert("There has been an error.");
            }
          });
        }else {
          alert('Please enter your email address and check the box below');
        }
      });
    }

    // Newsletter Modal - only appears when #newsletter-signup hash is in the url on the homepage
    const siteUrl = new URL(window.location.href);
    const newsletterModal = document.querySelector('.c-newsletter-modal');
    const newsletterModalForm = document.querySelector('.c-mailchimp-modal-form');
    const newsletterModalFormMsg = document.querySelector('.c-newsletter-modal__message');
    const newsletterModalFormHeader = document.querySelector('.c-newsletter-modal__header');

    if(siteUrl.hash === '#newsletter-signup') {
      if(newsletterModal) {
        setTimeout(() => {
          newsletterModal.classList.add('is-active');
          newsletterModal.querySelector('.c-newsletter-modal__close-modal').addEventListener('click', ()=> {
            newsletterModal.classList.remove('is-active');
          });

          newsletterModalForm.addEventListener('submit', (e)=> {
            e.preventDefault();
            const checkbox = document.querySelector('.c-newsletter-modal__form-disclaimer-checkbox');
            const emailAddress = document.querySelector('.c-mailchimp-modal-form input[name="email"]').value;
            let user = {};
            user.email = emailAddress;

            if(emailAddress && checkbox.checked) {
              $.ajax({
                  method: 'POST',
                  url: '/wp-content/themes/ventures/app/mailchimp.php',
                  data: user,
              }).done(function(response){
                if(response.toLowerCase().indexOf('member exists') >= 0) {
                  alert('You\'re already a newsletter subscriber.');
                  checkbox.checked = false;
                  document.querySelector('.c-mailchimp-modal-form input[name="email"]').value = '';
                } else if(response.toLowerCase().indexOf('member does not exist') >= 0) {
                  // Member gets added server side, show success message on frontend
                  newsletterModalForm.style.display = 'none';
                  newsletterModalFormHeader.style.display = 'none';
                  newsletterModalFormMsg.innerText = 'You\’ve been registered, thank you so much!';
                  checkbox.checked = false;
                  document.querySelector('.c-mailchimp-form input[name="email"]').value = '';
                  setTimeout(() => {
                    newsletterModal.classList.remove('is-active');
                  }, 2000);
                }
              }).fail(function(response){
                if(response.status === 500) {
                  alert("There has been an error.");
                }
              });
            }else {
              alert('Please enter your email address and check the box below');
            }
          });
        }, 1000);
      }
    }
  },
  finalize() {
    if (document.body.classList.contains('portfolio') || document.querySelector('.c-companies')) {
      portfolio();
    }

    if (document.body.classList.contains('blog') || document.querySelector('.c-posts__post')) {
      insights();
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js